import { useTranslation } from 'react-i18next';
import { supportedLanguages, type Language } from '@up2d8/contracts';
import { Select, cn } from '@up2d8/ui';
import { setLanguage } from './i18n';

/** De taalnamen in hun eigen taal (deviations §7); ook in het avatarmenu van het beheer. */
export const languageLabels: Record<Language, string> = {
  nl: 'Nederlands',
  fr: 'Français',
  en: 'English',
};

/**
 * Taalwisselaar. Op de vloer is dit vaak de eerste handeling van een nieuwe medewerker,
 * dus hij staat altijd op dezelfde plek en is met één tik te bereiken.
 */
export function LanguageSwitcher({ variant = 'default' }: { variant?: 'default' | 'sidebar' }) {
  const { t, i18n } = useTranslation();

  return (
    <div className={cn(variant === 'sidebar' && 'px-2 pb-2')}>
      <Select
        label={t('common.language')}
        hideLabel={variant === 'sidebar'}
        value={i18n.language.slice(0, 2)}
        onChange={(event) => setLanguage(event.target.value as Language)}
        className={variant === 'sidebar' ? 'h-10 bg-surface text-small' : undefined}
      >
        {supportedLanguages.map((language) => (
          <option key={language} value={language}>
            {languageLabels[language]}
          </option>
        ))}
      </Select>
    </div>
  );
}
